import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getIdToken } from '../../auth';
import { IRequestsRepositories} from '../../types/RequestRepositories';
import chalk from 'chalk';
import logSymbols from 'log-symbols';
import { getHttpErrorCategory } from "../../../src/Helpers/Http.commons"
import { BASE_URL_ENDPOINT } from '../../config/env';
interface IState {
  result: IRequestsRepositories[];
  error: null | any,
  resultado:[],
  statusCode: number | null | undefined;
  response: Object | undefined;
}

const initialState: IState = {
  result: [],
  resultado:[],
  statusCode: null,
  response: undefined,
  error: null
};


// console.log("este es el token en el RequestSlice***:", token);
export const fetchRequestRepositorysById = createAsyncThunk(
  'fetchRequestRepositorysById',
  async (idAsString: string) => {
    try {
      const token = getIdToken();
      const response = await fetch(`${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-request/${idAsString}`, {
        method:'GET',
        headers:{
          Authorization:`Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error(response.statusText);
      }
      const data = await response.json();
      console.log('data request by id:', data);
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const requestRepositoryUpdate = createAsyncThunk(
  "requestRepositoryUpdate",
  async ({ id, data }: { id: string, data: object }) => {
    try {
      const token = getIdToken();
      const requestData = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-request/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      const statusCategory = getHttpErrorCategory(requestData.status);

      switch (statusCategory) {
        case "Successful":
          return {
            statusCode: requestData.status,
            response: requestData,
            error: null,
          };
        default:
          return {
            statusCode: requestData.status,
            response: statusCategory,
            error:
              "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde.",
          };
      }
    } catch (error) {
      console.error(error);
      throw new Error("Error al procesar la solicitud");
    }
  }
);

const RepositorysSlice = createSlice({
    name: "repositorysSlice",
    initialState,
    reducers: {

    },
    extraReducers(builder) {
        builder.addCase(
            fetchRequestRepositorysById.fulfilled, (state, action) => {
                state.result = action.payload;
                console.info((logSymbols.success) + chalk.green('Result en el fetchRequestRepositorysById**:', JSON.stringify(state.result, null, 2)));
                state.error = null;
            }
        );
        builder.addCase(
            fetchRequestRepositorysById.rejected, (state, action) => {
                state.error = action.payload;
                console.error((logSymbols.error) + chalk.red('Result en el fetchRequestRepositorysById**:', JSON.stringify(state.error, null, 2)));
            }
        );
      builder
      .addCase(requestRepositoryUpdate.pending, (state) => {
        state.statusCode = null
        state.response = {}
        state.error = null
      })
      .addCase(requestRepositoryUpdate.fulfilled, (state, action) => {
        console.log('requestRepositoryUpdateSlice fulfilled', action);
        const { statusCode, response, error} = action.payload
        state.statusCode = statusCode
        state.response = response
        state.error = error
      })
      .addCase(requestRepositoryUpdate.rejected, (state, action) => {
        console.log('requestRepositoryUpdateSlice rejected', action);
        state.statusCode = 500
        state.response = 'Error en el servidor, testing',
        state.error = "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde."
      });
       
    },
});

export default RepositorysSlice.reducer;